// istanbul ignore file: experimental
import React from "react";
import styles from "./NodeStart.module.css";

export function NodeStart(): JSX.Element {
  return (
    <div className={styles["node-start"]}>
      <div className={styles.icon} />
    </div>
  );
}
